var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7979 14.7031C16.4131 14.7031 16.6855 14.2549 16.7646 13.8242C16.835 13.4727 16.8525 13.0156 16.8525 12.4971C16.8525 8.375 15.1387 6.49414 11.0781 6.49414H5.28613L3.19434 6.61719L5.76074 4.2793L7.72949 2.28418C7.90527 2.1084 8.01953 1.8623 8.01953 1.58984C8.01953 1.05371 7.61523 0.649414 7.05273 0.649414C6.80664 0.649414 6.56934 0.754883 6.34082 0.974609L0.557617 6.74023C0.355469 6.94238 0.241211 7.20605 0.241211 7.47852C0.241211 7.74219 0.355469 8.00586 0.557617 8.20801L6.3584 13.9912C6.56934 14.2021 6.80664 14.2988 7.05273 14.2988C7.61523 14.2988 8.01953 13.8945 8.01953 13.3584C8.01953 13.0859 7.90527 12.8398 7.72949 12.6641L5.76074 10.6777L3.18555 8.33105L5.28613 8.4541H10.9551C13.8467 8.4541 14.875 9.64062 14.875 12.5586C14.875 13.0508 14.8398 13.4023 14.8398 13.7363C14.8398 14.3076 15.2266 14.7031 15.7979 14.7031Z",
    fill: "#B2B2BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/icon-undo.13136d85d63da14a39c790697d72a25f.svg";
export { ForwardRef as ReactComponent };